export default "__VITE_ASSET__DHyZSOVY__"